// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '3688d6e7dc0acbb3fa916977d4639d93',
  adminEnterprises: '3dfdaccceebde8172b816649d9cd7d32',
  adminPcbBanManagement: '5e22eb3dfa06e97201b594d857b294a2',
  adminPools: '6a954585b747f57b5f4ec3209d78c3c3',
  adminProjectDescriptionUpdate: '80ee25c3b348b35337a81bdc97c2086c',
  adminUserDocumentSubmissions: 'cb1b10f0d8e2e56f6144bcfa8b15996a',
  adminUserEnterprises: '1cc08fb4667b5ab1271bb25872c03af1',
  adminUserPools: '1348e6e46173a87cc6d1978af799b063',
  adminUserVerificationProcesses: 'e50fdc5ba76285148b95908f9845b5a3',
  adminVerificationProcessTypes: '2c775d17e3c24746c1f1cac290962d7a',
  agentSessions: '72e0f8fe5c80a80764a12eb95ba15223',
  agents: '1250713baa66a29f54a9843d591d86cd',
  aiConsultantAudio: 'fd2e5f9c28d01c02963ef5e2d395416b',
  aiConsultant: '2b1542b3fea61d6ad5775d1e0862a8d9',
  aiPrompts: 'e40262fd7413e15961dfc010429cf489',
  allProjects: 'e8196b992ea65cf02233badc6522c466',
  analytics: 'fd6e29bae50560212ae0060acc8f2c94',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  articles: '1c7a8f59393a31290c65a57def365ce5',
  banners: '71411e700a799cb432e8f6d297ba5458',
  bidAwardDrafts: '4bdb7e717a8ce7e339b808ccfcc39e7b',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidDescription: '97de045865291ad18b5dec4449c82cbe',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidPitch: 'f38640454a19287e90d35a550db33dec',
  bidRestrictions: '2966f61d34246ade657e208528d4aa4c',
  bidScores: 'abf7389f299ca35ca24fca88c223b2d4',
  bidSummaries: '7d5ace0b55b64e31fa94713422e25ab0',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  bids: 'e87b68acd4c4321df2156c3a27c1532a',
  billingAgreements: 'eb9348e681260f4e9a3662191d0f6fa3',
  campaigns: 'e9b8b0accb91cf9eb0f204cb95ffd0be',
  canViewEmployerProfile: 'e4cd062351bbdf3e5ac60870fc756d88',
  cartApprovals: '144b1843c9c5213201fe9238928f6d78',
  cartItems: 'ea92e70874d51ac7b370ad5263a4bec7',
  carts: 'd031ad6617e27ded717a92b6f9fae0d3',
  categoryPageContent: '6735adbf5cff37e855b1056ebf374d8f',
  categoryPageViewUsers: 'e26d371c5adf550d6a9a9018e2fc2964',
  certifications: '43fd8862311f73a91a22f2e897799065',
  checkInSchedule: '5d75acbce6649a85b57ab06a21a776f4',
  commentFeeds: 'f3abc49f10dbd475b235297622d790eb',
  comments: 'b4cc971cdfd1da469dfa2c90572d0020',
  contactUs: '24e8637011e12e4aabc0e56351fed688',
  contacts: 'ea0263f70a017cbbd7f8171ca317cfe3',
  contentCustomization: '724b0856bf76e9bb4462cbee64354a1b',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestCollaborations: 'dbe3b1d3eb3e6c8749f8c876ed9a0606',
  contestComments: 'f7c0d794e15afbe67510057bab896401',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '35abb2fc97c56905d8e8171d23260c73',
  contestEntryMessages: '3f5ab3f4442354978c342be027847446',
  contestEntryOffers: '4b2413d572e0f8f8b616258e6ac8cc22',
  contestFees: '3f4d22a8c03fcb58bb55b5d361dc07b4',
  contestFiles: 'a6232d99e4264ffb391fb999eb3867fc',
  contestHandoverFiles: '1ea50837ab824445037081acaef31f78',
  contestHandovers: '9c806a73c198c2e8e6fd94f0c5b8662c',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contestInterestedFreelancers: '3fdb8a1653a2b93d78afeb2679590b3e',
  contestInterestedUsers: '24b5fb96b0f09d45a2fb190fb92892d3',
  contestInvite: 'f06aea98eeae00234f7e734b108ba73c',
  contestMessages: '065919599825ded694989467bb2b7ad3',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestPolls: 'd6f47e4b8b7db7c84efa7e82ce0a5b70',
  contestPrizeDetails: '76b6865ac39718712f8f3306206708b4',
  contestQuickviewEntries: '87170de12e60b2099c4a184920e215ea',
  contestRubricSubmissions: '7cc35149f4da347798ebf365c77740a9',
  contestRubrics: 'd88b55b6d86877e1c21340e46ee86361',
  contestViewContests: '95e780cc1852ab30c8de4d7a4765ac4a',
  contestViewEntries: '62342a9c8e6b5a6a8433530398de1809',
  contestViewEntryIds: '2fedeb6f70be9f3d87b96332ca7eb583',
  contestViewNewOrUpdatedEntries: '62b044801e8c0866983e8371ee004aef',
  contestsInterestedIn: '0782237f0759504816d475e51da60469',
  contestsSelfInsights: '6d4a26f1f9e583f35f315779173b83c0',
  contests: 'cfcb7aeba66bb95f3b34066ac24155fd',
  contractDownloadUrls: '28fe0231a716f682931f796f2a3a8adc',
  contractSigningUrls: 'c3cdd724390e5f863b2df078ec12c9d6',
  copilotChat: '51566d63a482f71676f91009a0df1b9a',
  copilotEnquiries: '237ebf3a39957f06cf20439b5bd40082',
  countries: 'd84355b6576cf5c6a700adf325033d34',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  currencyDetect: '7de9b2df5bf61db45209b0276ae15363',
  customBanners: 'da16e6beda9d8a6f8bde40afb1c2c1f3',
  customFieldInfoConfigurations: 'bbff3816f6a3095ed7b6d62fd6753948',
  customFieldRelationships: '760f934980f29120c1c1cf00b61fac50',
  customFieldValidations: 'b8695c250448d24c001f702331656e89',
  dashboardPolls: '4a5ec8404c9cc72f492206255a087633',
  dashboardWidgets: '744107b82ab567eb58e6890ed6217c1d',
  deleteCommentsByUser: '4ec1ffe95368ad9cac2c1f2c23cde450',
  deleteFeedsByUser: '016da683162ef0513d923ab25b7eba4d',
  deloitteSubscriberEmails: '2a956b3ce9896b790432b92033dcee4b',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: '8bb0726943268b06e681380cd2d20082',
  depositPageVars: 'dbd11276cbcd1928a88e2a4eebf7cfdc',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  developerTokens: 'ae77f04e1068b8e15782e70604eceda3',
  discoverCollectionItemSaveCount: 'ee3fb67e46172b6cb612295484893b81',
  discoverCollectionItems: '991e682da4aeb531fbe5cc5a74273808',
  discoverCollections: '52a491a41aee193d2846868905a1b30d',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '35b7f881fba5ea2784e30179c94622c8',
  educations: '8e7f7e3d902633deb708d813bb61e9dc',
  emailLeadCapture: '7df8449a7c15a826e66557f13af0f4ee',
  employerReputationsRehireRates: '5fc9a744d2ba688513624a7529f6475e',
  encodedUrl: '44db17c46c57d7831b9e560e1613b31e',
  enterpriseBillingAgreementsBalance: '388804f8cb93db4aa1acfb33a03d7c72',
  enterpriseContact: 'f9f4efad2b2f6589c7041036526d80a5',
  enterpriseLoadshiftCancelGrandfatheredMembership:
    '8bf8f74068ccb1adc336b38cee4546e9',
  enterprises: '62aaf5c23e5f6081a98a7471b8e15e3e',
  entryRestrictions: 'ea3db3b6c92b7010b0ded1e33056435b',
  equipmentGroup: '4a0f9784c610532ed7be41695545121b',
  equipment: '401a6e037ec2892bf5110d5e3795d3a8',
  exams: 'a490e8e606bf16f4f0f200c31d54e47f',
  exchangeRates: 'e3eddbf66ac9e18a5e4319e8a12f34ac',
  experiences: '40986fee31964385e45bc33aef538cf7',
  feedMeta: '5d219e63f1e8ab6a7a1df92c03b5b58d',
  feedPosts: 'b835f43cca417a6961a41b27b0b8b340',
  feed: '53603b0872e9b03fd535d7dca612c192',
  feedback: '992692453e8a744e215e402b7464575c',
  fieldServicesTalent: '6812eafadad1e4e3692a188745ae2e41',
  findPageDetails: '0aae1d241f180ee5989c3fc36ebd7a88',
  freeRecruiterUpgrade: '97f72ba05979e6f39e7d22c3d36eda36',
  freelancerReputationsRehireRates: '0819033161bfa0f3a05d00f53073f5db',
  freelancerReputations: '5f86ecc9f74339e90bbef7e3e9b8b76b',
  globalFleetContact: 'bf1cb95f2ffd3b77a09962f62f2ffeab',
  grants: '65f472dbb1885f7a06c5ce9ef640dc99',
  groupActions: '19fec4d55eabda7f893205ffd0daee59',
  groupAttachments: '44db5335e07d07a1c336502beda3d479',
  groupFeed: '983a0686ad6468720e1cccbc9ed9ec7e',
  groupMembers: '0774a673b3c90691fd3fe1566e8dc0a9',
  groupPermissions: 'f74fa869aebb39ea8facbd8688f872c7',
  groupsSelf: '1d3b42f3bc3e780532ae98faaf99c15f',
  groups: '1d3b42f3bc3e780532ae98faaf99c15f',
  guidelines: '68e44b5a32841d668d1e92fc8360a722',
  harvardContacts: 'ccb97e3799d37a708417df8bc7cc3b83',
  hirePageDetails: 'fd166c2c221dc94ee4c45091bb7a739e',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  insightsBids: '276a49cd9bd766cd5a252ee5d337069c',
  invitationBlocks: '6a76355a8a942ecbba5b5c52ae56e575',
  invitations: '4c859a8d124a8e1f61e061f7808b6b12',
  invoices: '11248bfaa18fee68d253cba4ed83bb43',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  isLookingForWork: 'c90fd79bdd9648b0dcd3fc7c80d05651',
  issuingInstitution: '191c5080a6cbb19009eb2935e758f46b',
  jobClassifier: '8d0cb74f449a0a11931133e83a9ad446',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  loadshiftSiteStats: '57aa1b2f6359704fda2e9a2dedf158ba',
  loginDevices: '3e1afdf4e5bf7fb5e73390edd4984dcd',
  manageViewContestHandovers: '5d820e32bafe59f9347ef9bf275045e6',
  manageViewContests: '73658c1dcba604e25a0fcf0898143e55',
  manageViewHandovers: '04c3c3abcbcac656728f045191dea931',
  manageViewOngoingBids: '12f9cfe0cf7cf4a60dc8b94aa90e1f50',
  manageViewOngoingProjects: '2155764961ee104bcdc7063832bfd80b',
  manageViewOpenBids: '972809a1c4e167e8d1e4ee36604d7ad7',
  manageViewOpenProjects: 'a3d09a0e28f9a2357159b20662dcb7ec',
  manageViewPastBids: '3ddb0415a8a2d91995270bffc69a50d6',
  manageViewPastProjects: 'a2715b3ff61601d6ee40ec3a7b5d86ee',
  marketingMobileNumber: '6d57111b5240989328fd6d7825247fe3',
  membershipBenefits: '1b3935953dfa7f6cad67f08a5e93380a',
  membershipDowngrades: '50b9485c910e81d92e1401e3ad1e5886',
  membershipPackagePrices: 'fa6e18fcf9dbc6654c1be4b8e3085d28',
  membershipPackages: '0593136eebe94e9ad4ebcdf6445e72e3',
  membershipRenewals: 'e357585dfa2f66ce9a1f79858a85bd95',
  membershipSale: '55fbeb62a6e565505a75dc3f9976634c',
  membershipSubscriptionHistory: 'cc453171cfe1fbe99a7e7d4bdc2089bd',
  membershipSubscription: 'e857bce84db7cabcdd1541e8b59d4c49',
  membershipTrials: 'ff61d0616faa339d81168e379fc03f70',
  messageAttachments: 'c3f3b324e96a4dc0ecb0fa662b05da53',
  messages: '340939c3661ffdfac2e2d9d449a45ad2',
  milestoneDrafts: 'f11b88854b984bd391b567b18c3af8ed',
  milestoneRequests: '840a5f69fca7f2a9e176ee34e3542069',
  milestones: '44e6ba8e6ec559a5ebc3517b3174bb2a',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  mygigsExpressionOfInterest: '91301a124c27f055daa04eae6179c50d',
  nativeExchangeRates: 'e3eddbf66ac9e18a5e4319e8a12f34ac',
  nearbyProjects: '7a4cca4f53eeccabb0aea8253192860d',
  newsfeed: '026205559e04dd6fc0cf733b049f4d78',
  nextPreviousUsers: '84ead1aaa99dc711b4f7027f20a4ffc2',
  nextProjectRecommendations: '3cc469a543cf097dd847b550a4d0112a',
  notificationSettings: 'f9f8604714c8832b680f2bbaff2b56bf',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  notifications: '019c9dddf17b79c3e485dbdc95417690',
  onBehalfProjects: 'fde990838cb370a3ab9289c4958fb15e',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  openGraphDetails: 'b6ab3861eee0427fca4cf3520ef15abd',
  operatingAreas: '6315564555c3b367c2d274b2be650453',
  paymentShareInterests: '2dfbb50654bee0dfbfefdf174c53b594',
  paymentShareMembersSpendingDetails: '44105cc7ca131d371d85b9cda7435592',
  paymentShareMembersSpentAmount: '3464028ae93ed58778bd508875f70997',
  paymentShareMembers: 'df27633826da5d3e3026a0fad7e70358',
  paymentShareTeams: '164df671004b9dbd8f417ecd09436216',
  paymentShareWhitelistItems: '21b6c79935ff7da502a41309b33e4fd4',
  payoutAccountForm: '0f23629cc18d23b2624400d1fe1f73cc',
  payoutAccounts: '44eccf32823e257a3cbc88434132f4a5',
  payoutContext: 'faeba93132cbba8d18a94f900eca3abd',
  payoutLimitExemptions: '3d274d832b852dc6acc98f06eb63002d',
  payoutMethods: '92f2004d858af89162952db738135e26',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pfpSkills: 'c385d285d53b8bf4d40fcaedf8affbb0',
  pfpStatus: '4f2c9e4711e1703f733844833d2476a2',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  pools: 'a11cd48cde19a8772346b9ed386cc890',
  portfolios: 'b397d39a7d1f5955f0eabb4eb5e9b6d2',
  postFiles: 'f226d954dbdecb6da37be039cbfd512d',
  postJobPageDescription: '92f1484599328574fa5cbd837847aab8',
  postJobPageFormState: '804e94dfc5f201aca596fb448263a31b',
  postJobPageQuestions: '9b31f6cf727eee5b3e237908da8dc566',
  predefinedDiscoverCollections: '52a491a41aee193d2846868905a1b30d',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  preferredBillingAgreements: '5e5b89821e0a10c922fc1fe4c00b5729',
  profileCategories: '227affabc12184d336a726cd136489ed',
  profileViewUsers: 'a5554979fac7069b1615436ef16f2d7f',
  profiles: 'b269ab37e0828345424a8f3b292001a1',
  projectBidInfo: '488aff12d66a62bc0d6f48b875c8d0ce',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '7fee7f1d7ebd65b430377918a42ce486',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectFeedFailingContests: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectFeedFailingProjects: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectFeed: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectGroups: 'c11f55395fee67f29936fde8ebd50214',
  projectInvite: 'd88f62eaadcb2ebd35a51e815efbf160',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projectQualityDetails: 'e5dec7981b77b82b0dafc18d7a37774b',
  projectSpamControls: 'd6a17d28a2a784e04e545ff3802dc6ff',
  projectStats: 'd3233413cbe6fca69a15a487c7a3b751',
  projectTitleEditRequest: 'dc4b523352a59b92007eb6a8beda687f',
  projectUpgradeFees: '0dfb153e40e347289a9e291d129716c4',
  projectViewBidderLocations: '4155ba632cbfefd6d6f756fe640dd3b5',
  projectViewBids: '200494e9e3c212a9c9dd306d66939b50',
  projectViewProjects: '015c09f1295eadf4ba83c1c0d643a3e3',
  projectViewUsers: '8ae38ef5a75465e731eaa85a5d29168f',
  projectsSelfInsights: '811ba7045bc5d3f1c9f6e70e58f0dfe3',
  projectsSeo: '88bfd2a15bb15d943f97560591441f55',
  projects: 'f0598952c2fc4f4e4ba6ee65b6411f5a',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  quotationFundRequests: '4a0bc7d5c9e16816b1a2807cda19af7d',
  quotationFunds: '9de2e842f1c177afcdbc2a7cc0be74e0',
  quotationItemRevisions: 'f7faedd7e54585b2371b3e7471b491a9',
  quotationLogos: '2912f2c3e8f58b953986359c26789d34',
  quotationRevisions: '2a2c783d7dd25bde90aa19e4f4bbba16',
  quotationWhitelist: 'd5b9567e6615b0cfcfadf90db47c643c',
  reactionsTypeCount: 'c8e2bc130bdfa81a8d6688a5cfeb3b71',
  recentSavedSearchAlerts: '937bc55ddbcb405f091fd068189eb307',
  recommendedMembership: '136b2dc1686addd12e396cc73176828a',
  recommendedUpgrade: 'f8d027a7f45c8d7b8234589b6fe3f227',
  recommendedUsernames: 'c1730888439c6e53b0b7c05b9e7edef2',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  recurringBillingInformation: 'e680dfc697951c6aafd80e124dcfe9e6',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  referralToken: '5c8adf6f78112fb9e94f52bf06a46532',
  reviewsSkills: '3ed5c1a7ee988dfeed7aceb5641ffebe',
  reviews: 'd6abcd627fc12bed95c02f201f632529',
  salesTax: '48b3aad4850275c7e718b9015e58561c',
  savedSearchContexts: '932deb120ebf7c09ac608cd3f25c289c',
  scheduledSubscriptionPayments: '2638a2e86ab69cf321d3e10c8cfe52d3',
  searchActiveContests: '82ff34044e63360f1ce37ad3666825b4',
  searchActiveLoads: '4d31e6cff2a765624c9c7cb5904128f6',
  searchActiveProjects: '772605109fc777ccc34f2342901103a3',
  searchAllProjects: 'f0598952c2fc4f4e4ba6ee65b6411f5a',
  searchClosedContests: '82ff34044e63360f1ce37ad3666825b4',
  searchContestEntrants: '16c81d21c56d0f1b5ec1929be770feae',
  searchContestEntries: '62342a9c8e6b5a6a8433530398de1809',
  searchFreelancers: '59790ae02045d1b1a8fcd4eb0284fd9d',
  searchKeywordProjects: '1f5af6a224fb12cd6c5bebf038916efe',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchProjectsSelf: 'e3cf76608cb456162809f92b333928f5',
  searchSavedFilters: 'd9ad82c6d8ccb7aae51f8046a8677624',
  searchThreads: 'f52b8594bce79a97e5427b33615b6075',
  searchUsers: '1e57a1e99e5de738634757895ef138b3',
  securityPhoneRequests: '524c1ee68465953f496b8cf1450d8bd6',
  semDynamicPageContent: '9f595bbcb56e0aee9b4d889c486a37b4',
  seoNavbar: '8e5b1dfa322833dc975cdeee75bbb014',
  serviceOfferingAttachments: 'fd5c0dc64756a887e5bb67c76a8f78b7',
  serviceOfferingBuyerHistories: 'a2e65d6732e073a86bad449ca3bcd47c',
  serviceOfferings: '317ba763f7cd14ab3b074772fd78d7b5',
  sessionResolveReasons: 'ccef8c648e4a1947b6dd8c0bcfea327c',
  showcaseSource: 'e9d95438f258ffe530b4e2ef139e30ae',
  showcase: '3ac5c5476e5644e658956faaf1d3f857',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  skillBundles: 'd00f17bc6add44c135e16d1641a0d65f',
  skillsSubNavigation: 'b53931bf59b48506b398c94c42f675a7',
  skills: 'b0b9d47616e234db600127beb4ebf884',
  subscriptionItems: 'a2db7875097ae701b02602277cde8770',
  suggestedSkills: '74db00b149426fa76661ddd86621e02d',
  superuserAgentSessions: '72e0f8fe5c80a80764a12eb95ba15223',
  superuserBids: 'e87b68acd4c4321df2156c3a27c1532a',
  superuserGrants: '65f472dbb1885f7a06c5ce9ef640dc99',
  superuserGroupMembers: '600efb0e333c1d696c82de77cab69374',
  superuserGroupPermissions: '9abb162bc6a3c0f3f2bf4bc9c02a1ecc',
  superuserGroups: '1d3b42f3bc3e780532ae98faaf99c15f',
  superuserMessages: '340939c3661ffdfac2e2d9d449a45ad2',
  superuserMilestones: '44e6ba8e6ec559a5ebc3517b3174bb2a',
  superuserProjectCollaborations: '7fee7f1d7ebd65b430377918a42ce486',
  superuserProjectNotes: 'c3e863437fda2a6c41660d9f8986675e',
  superuserProjectViewAllProjects: '26e66211aedd3c144af942ff493d55aa',
  superuserProjectViewProjects: '015c09f1295eadf4ba83c1c0d643a3e3',
  superuserProjectViewUsers: '2e28a811f17978a49dc82ca7092bd9c4',
  superuserRoles: '318c3789f0d1dbf320b4b840ecd65022',
  superuserSearchThreads: '3110894a8bbe0c2e68f2740f4b97bf34',
  superuserTaskGroupSections: '4f685d834c91aa4b2eebe5403d1287f6',
  superuserTaskGroups: '788412e44e92b844567a588ead6f3b74',
  superuserTasks: '6bff96e4921ded6f44d7aa338d32502b',
  superuserThreads: '3110894a8bbe0c2e68f2740f4b97bf34',
  supportFeedbackIsAllowed: 'ec1a2ab220bf6ae718f3c31e2e96466b',
  supportFeedback: '0c8652b987faa5ed17604f4ade25657d',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  taskGroupMembers: '892902b8b45557eb39bc50e6c4d09079',
  taskGroupSection: '4f685d834c91aa4b2eebe5403d1287f6',
  taskGroup: '788412e44e92b844567a588ead6f3b74',
  tasks: '6bff96e4921ded6f44d7aa338d32502b',
  taxOptOutOptions: '8d79bd6dc2409d1834e732b384935a60',
  taxStatement: '9e2ea0d97d15d2022fe1ad0f20a81b4b',
  tax: '269061e1c3f348f62dbd36fd55f74e0f',
  teamInvitations: 'e5f12a8e06582e4a05b1d13fd5310717',
  teamMembers: '72012171395c87039424bc159d92f2e3',
  teams: '7fb269056325fb6d64b2a7ebe207fbad',
  threadProjects: '702d5e96ff6c2c4689d9794517f44242',
  threads: 'f52b8594bce79a97e5427b33615b6075',
  timeTrackingDailyAggregates: 'cf0b1a2d3b1818f710fd8b075d328e75',
  timeTrackingPunches: '9ff76aece40ce374f50010c58e10c17e',
  timeTrackingSession: '80a6c6bc3554ed72d60b21f37512b918',
  timelines: 'e680f761feae1625e1f133d8128158aa',
  timezones: 'e03b2867faa42e4a71b0c8dfe5ed2c0e',
  toastNotifications: 'd9ce7551aba9411713514606e77c6c16',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  tracks: 'e432997983ba0bedffd22d84f0d1e939',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  twoFactorDetails: 'bf5a516c4382437117e334903aaeae3c',
  unconfirmedAwards: '43d84cabe984ae6717efa8218ad6d763',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  userAvailabilities: '5a5e18544b02d53b092843ac6b1eb9f9',
  userBalances: '19562fd91f748c6097966018189e5985',
  userBidLimit: '02e82788a8467ff18539b987ac7227b6',
  userBidOnRussianProjects: 'f799113d4a5ebf40db8efef7a9499eab',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userContestCollaborationWhitelist: '507680d8d3c0c2ea30ea86cb99166a55',
  userCustomEmails: '247c86a075d5ac5709031cafd4a84026',
  userDepositMethods: '032f9ac5ab0544e020e9781ce0059f4b',
  userDocumentSubmissions: 'cb1b10f0d8e2e56f6144bcfa8b15996a',
  userEmailRequest: '86011c5edfba0d2ee6d1c29ec86d7c01',
  userEnterprises: '1cc08fb4667b5ab1271bb25872c03af1',
  userFees: 'cc1806b6b645506e3cdfcf58c146f13d',
  userGiveGetDetails: 'f0ab8506bcbdd472a808f737b969dff6',
  userHasDuplicateIp: '3f2340a4213ed9be96b40660bfc2bad2',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: 'e8ae1bc08955551eae05a678f013f768',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userIpLocation: '75e3f8f983041d7582cb0cc4f81dc986',
  userLastOnline: 'bdd8436d650e5dbd3b19e46a596afab3',
  userNotificationPreferences: '07e54bad115380b453bec71a22a807cc',
  userNps: '4cbf9dfa2ab3c351d16e8489d8977f8d',
  userParsedResumes: '432d95a91ea92debd3784e91a11a2b96',
  userPaymentControls: 'd4c613748f8b6fef5513faf94501bf5f',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userPhoneVerificationBackoff: 'e1f3b584ec2dccae08f694e648be3f62',
  userQualityDetails: '0dcc0040a73b7995229e380b160abcd6',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  userRequiresEmailVerification: 'e2f0beae240a0912172c652af0c3eb4e',
  userRequiresGdpr: '1f1923492a3b9ecbd2ce5b3c9c9d1b28',
  userRequiresPaymentVerification: '2c3c2819f099d4c23433dd0a56355caf',
  userRequiresPhoneVerification: '2ce7a52a3a029abb98242e9b00337ddb',
  userResumes: '1a461d39770bc29217ae80edd63736af',
  userSettings: 'c569c4c852a0b8be2d85c07a317740b5',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTaxInfo: 'fee8d6d9e2e14d52eeb6012ef320e606',
  userTaxOptOutReasons: 'ce314c12bd90c530be886124e798b455',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  userVerificationProcesses: '69ef6d0e592c911c6275357dc8c18bc3',
  usersFollow: 'bbea0e01511c4dca66ded193ee07fca0',
  usersLocation: 'a05c972d91e02b4ad20f0d1611867cae',
  usersMfa: '6a39c996b736babac9262c3e7f5e7104',
  usersProfileImage: 'e97d332d6bb3ee806476de0483c34df7',
  usersProfile: '00bb17ff7d1f397924827f07198dc44d',
  usersRecommend: '0a80e5d13a75c26e4e765d9042d3acb6',
  usersSelf: 'b2818cd41929489962908be7a7458da3',
  usersTeamProfile: '00bb17ff7d1f397924827f07198dc44d',
  users: 'cf97c2a9e60d52fa2b8095bc23fb77a5',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationProcessTypes: '2c775d17e3c24746c1f1cac290962d7a',
  verificationRequest: 'f9366dfbb548d1eb4b03504af4bc6914',
  videoVerificationRequest: '3b556aa9cf434dea06b9bad37da7ab83',
  violationReports: 'a5de0588521f22b39d868aab891f3055',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
};
